import { render } from "./Footer.vue?vue&type=template&id=a6795ba8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a6795ba8&scoped=true&lang=postcss"
script.render = render
script.__scopeId = "data-v-a6795ba8"

export default script